import { Injectable } from '@angular/core';
import {configURI, configURI2} from '../../../shared/apiUrlConfig';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { ServerDataSource } from '../../../../node_modules/ng2-smart-table';

@Injectable()
export class ComplaintsDashboardService {
  private complaints = "/complaints";
  url = environment.configURI;
  lastRequestCount: number = 0;
  source: ServerDataSource;
  constructor(public httpClient: HttpClient,
    public userFriendlyMsgs: UserFriendlyMsgs) { 
      this.source = new ServerDataSource(httpClient, { endPoint: `${this.url}${this.complaints}${'/active'}` });
    }
    
  // getListOfComplaints (){
  //   return this.httpClient.get(`${this.url}${this.complaints}${'/active'}`).catch(this.userFriendlyMsgs.errorHandler);
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/complaints_dashboard/complaints-dashboard.service.ts